import React, { useState } from 'react';
import { Button, Card, Table, Badge, Spinner, Alert,Modal } from 'react-bootstrap';
import { FaUserPlus, FaEdit, FaTrashAlt, FaKey } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useUsers } from '../../../hooks/useGetUsers';
import NewUser from '../../Modals/Create/NewUser';
import ChangeUserPassword from '../../Modals/Update/ChangeUserPassword';
import { useDeleteUser } from '../../../hooks/useDeleteUser';
import { toast } from 'react-toastify';



const UtilisateursTab = () => {
    const [showNewUser, setShowNewUser] = useState(false);
    const [userForPassword, setUserForPassword] = useState(null);
    const navigate = useNavigate();

    // Fetch users from API 
    const { data: usersData, isLoading, isError } = useUsers({ includeInactive: true });
    const { mutate: deleteUser, isPending: isDeleting } = useDeleteUser();
    const [userToDelete, setUserToDelete] = useState(null);

    const users = usersData?.data || [];

   const handleDelete = () => {
    deleteUser(userToDelete.id, {
        onSuccess: () => {
            toast.success("Utilisateur supprimé");
            setUserToDelete(null);
        },
        onError: (err) => {
            toast.error(err.message);
            setUserToDelete(null);
        },
    });
};

    if (isLoading) {
        return (
            <div className="text-center py-5">
                <Spinner animation="border" role="status" style={{ color: "#4e73df" }}>
                    <span className="visually-hidden">Chargement...</span>
                </Spinner>
            </div>
        );
    }

    if (isError) {
        return (
            <Alert variant="danger" className="mt-3">
                Erreur lors du chargement des utilisateurs
            </Alert>
        );
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h5 className="mb-0">Gestion des utilisateurs</h5>
                <Button variant="primary" className="btn-icon-split" onClick={() => setShowNewUser(true)}>
                    <span className="icon text-white">
                        <FaUserPlus />
                    </span>
                    <span className="text">Ajouter un utilisateur</span>
                </Button>
            </div>

            <Card className="border-left-utilisateur shadow mb-4">
                <Card.Header className="py-3">
                    <h6 className="m-0 fw-bold text-utilisateur">Liste des utilisateurs</h6>
                </Card.Header>
                <Card.Body>
                    <div className="table-responsive">
                        <Table hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Nom</th>
                                    <th>Prénom</th>
                                    <th>Email</th>
                                    <th>Téléphone</th>
                                    <th>Rôle</th>
                                    <th>Couleur</th>
                                    <th className="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {users.length > 0 ? (
                                    users.map((user) => (
                                        <tr key={user.id}>
                                            <td>{user.id}</td>
                                            <td>{user.name}</td>
                                            <td>{user.surname}</td>
                                            <td>{user.email}</td>
                                            <td>{user.phone_number || '-'}</td>
                                            <td>
                                                <Badge 
                                                    bg={
                                                        user.role?.name === 'ADMIN' ? 'danger' : 
                                                        user.role?.name === 'MANAGER' ? 'warning' : 
                                                        user.role?.name === 'TECHNICIEN' ? 'info' : 
                                                        user.role?.name === 'SUPPORT' ? 'secondary' :
                                                        user.role?.name === 'CLIENT' ? 'success' : 'dark'
                                                    }
                                                >
                                                    {user.role?.name || 'N/A'}
                                                </Badge>
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center gap-2">
                                                    <div 
                                                        style={{
                                                            width: '20px',
                                                            height: '20px',
                                                            borderRadius: '50%',
                                                            backgroundColor: user.color?.hex || '#cccccc',
                                                            border: '1px solid #dee2e6',
                                                            flexShrink: 0
                                                        }}
                                                        title={user.color?.name || 'pas de couleur'}
                                                    />
                                                    <small className="text-muted">{user.color?.name || '-'}</small>
                                                </div>
                                            </td>
                                            <td className="text-center">
                                                <Button
                                                    variant="link"
                                                    size="sm"
                                                    className="me-2 p-1"
                                                    title="Modifier"
                                                    onClick={() => navigate(`/administration/utilisateur/${user.id}`)}
                                                >
                                                    <FaEdit className="text-warning" />
                                                </Button>
                                                <Button
                                                    variant="link"
                                                    size="sm"
                                                    className="me-2 p-1"
                                                    title="Changer le mot de passe"
                                                    onClick={() => setUserForPassword(user)}
                                                >
                                                    <FaKey className="text-secondary" />
                                                </Button>
                                                <Button
                                                    variant="link"
                                                    size="sm"
                                                    className="p-1"
                                                    title="Supprimer"
                                                    onClick={() => setUserToDelete(user)}
                                                    disabled={isDeleting}
                                                >
                                                    <FaTrashAlt className="text-danger" />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center text-muted py-4">
                                            Aucun utilisateur trouvé
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Card.Body>
            </Card>

            <NewUser showNewUser={showNewUser} setShowNewUser={setShowNewUser} />
            <ChangeUserPassword
                show={!!userForPassword}
                setShow={(v) => { if (!v) setUserForPassword(null); }}
                user={userForPassword}
            />
            <Modal show={!!userToDelete} onHide={() => setUserToDelete(null)} centered>
    <Modal.Header closeButton>
        <Modal.Title>Confirmer la suppression</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        Supprimer l'utilisateur <strong>{userToDelete?.name} {userToDelete?.surname}</strong> ?
        <br />
        <small className="text-muted">Cette action est irréversible.</small>
    </Modal.Body>
    <Modal.Footer>
        <Button variant="secondary" onClick={() => setUserToDelete(null)}>
            Annuler
        </Button>
        <Button variant="danger" onClick={handleDelete} disabled={isDeleting}>
            {isDeleting ? <Spinner size="sm" animation="border" /> : "Supprimer"}
        </Button>
    </Modal.Footer>
</Modal>
        </>
    );
};

export default UtilisateursTab;